let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fHyBm")).then(() => parcelRequire('3kLG4'));